module.exports = __webpack_public_path__ + "img/font_palatino-linotype.37d21ef.svg";